/**
 * Finders whose sidebar chapter icons are centered in the square tile instead of cropped from the left (KON-2110).
 * Only the listed tiles (zero-based position in the sidebar) are centered; card photos in the other tiles keep
 * the bank logo on the left. Finder ids repeat across environments and tenants, so match the pair.
 */
const FINDERS_WITH_CENTERED_SIDEBAR_ICONS = [
  // Volksbank Zollernalb (prod): Mitgliedschaft and Konto
  { finderId: 11000, tenantId: 1093112, chapterIndexes: [0, 1] },
];

export function isSidebarIconCentered(pagesFlow, chapterIndex) {
  const finderId = pagesFlow?.finder?.id;
  const tenantId = pagesFlow?.tenant?.id;

  return FINDERS_WITH_CENTERED_SIDEBAR_ICONS.some(
    item => item.finderId === finderId && item.tenantId === tenantId && item.chapterIndexes.includes(chapterIndex)
  );
}
